import { Outlet } from "react-router-dom";
import moment from "moment";
import "moment/locale/en-gb";
moment.locale("en_US");

function MainLayout() {
  return (
    <main>
      <Outlet />
    </main>
  );
}

export default MainLayout;
